export const sortListing = (inData, sortingAlgo = "titleAZ", brandsFirst = false, isSpecials = false, priceKey = "member_price") => {
	let sortingAlgorithm;
	
	let brandSeparationAlgo = (a, b) => {
		if (a.product_code.toLowerCase().includes("_info")) {
			if (!b.product_code.toLowerCase().includes("_info")) {
				return brandsFirst ? -1 : 1;
			}
		} else if (b.product_code.toLowerCase().includes("_info")) {
			if (!a.product_code.toLowerCase().includes("_info")) {
				return brandsFirst ? 1 : -1;
			}
		}
		return 0;
	}


	try {
		switch (sortingAlgo) {
			case "priceLowHigh":
				sortingAlgorithm = (a, b) => a.prices[priceKey].price - b.prices[priceKey].price;
				break;
			case "priceHighLow":
				sortingAlgorithm = (a, b) => b.prices[priceKey].price - a.prices[priceKey].price;
				break;
			case "TitleAZ":
				sortingAlgorithm = (a, b) => a.title.localeCompare(b.title);
				break;
			case "TitleZA":
				sortingAlgorithm = (a, b) => b.title.localeCompare(a.title);
				break;
			case "biggestSaving":
				sortingAlgorithm = (a,b) => b.prices.savings_amounts.gold - a.prices.savings_amounts.gold;
				break
			case "recent":
				sortingAlgorithm = (a,b) => Date.parse(b.edited_date) - Date.parse(a.edited_date);
				break;
			default:
				throw new Error(
					"Invalid sorting algorithm " + sortingAlgo
				);
		}

		if (isSpecials) {
			return inData.slice().sort(sortingAlgorithm); //make copy before sorting
		}
		return inData.slice().sort(sortingAlgorithm).sort(brandSeparationAlgo); //make copy before sorting
	} catch {
		console.error("error sorting ", this.sortingAlgo);
		return inData;
	}
}